import { useResumeReview } from './ResumeReviewDetail'
const useIsActionable = ({ revisionNumber }) => {
  const {
    coachRevisions,
    status,
    meetingViaCalendly,
    completedEvents,
    displayStatus,
  } = useResumeReview()
  const currentResumeReview = useResumeReview()
  const coachRevisionsLength = coachRevisions?.length || 0
  const currentRevisionIsNext =
    (coachRevisionsLength == revisionNumber &&
      !currentResumeReview.revisionDeclined) ||
    (revisionNumber === 2 && currentResumeReview?.revisionDeclined)
  const hasCompletedEvents = (completedEvents?.length || 0) > 0
  const noShowOne =
    displayStatus === 'Assigned to Coach' && status === 'scheduled'
  const noShowTwo =
    displayStatus === 'Awaiting Candidate Response' &&
    status == 'revision_meeting_requested'
  if (revisionNumber === 2 && status !== 'closed') {
    return true
  }
  if (status === 'cancelled') {
    return true
  }
  if (!currentRevisionIsNext) {
    return false
  } else if (status == 'scheduled' && hasCompletedEvents) {
    return true
  } else if (!meetingViaCalendly && status === 'assigned') {
    return true
  } else if (noShowOne || noShowTwo) {
    return false
  } else if (
    ['revision_requested', 'revision_meeting_requested', 'scheduled'].includes(
      status,
    )
  ) {
    return true
  } else if (
    status === 'revision_returned' ||
    status === 'final_revision_returned' ||
    status === 'revision_declined'
  ) {
    return true
  }
  // console.log(
  //   `Current revision ${revisionNumber} is next, but not actionable.`,
  //   status,
  //   meetingViaCalendly,
  // )
}
export default useIsActionable
